
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import apiUrl from "../../environment/Api";
import "../../assets/css/Addstudent.css";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import { useLocation } from "react-router-dom";

const steps = [
  "Step 1: Personal Details",
  "Step 2: Address Details & EMI",
  "Step 3: Confirmation",
];

function Registration() {
  const [responseDatas, setResponseDatas] = useState([]);
  const [responseData, setResponseData] = useState([]);
  const [responseOldData, setResponseOldData] = useState([]);
  const [branch, setbranch] = useState([]);
  const [generateregisterData, setgenerateregisterData] = useState([]);
  const [updaatedDatass, setupdatedDatass] = useState({});
  const [roleId, setroleId] = useState({});
  const navigate = useNavigate();
  const handlecancel = () => {
    navigate("/Walkin");
  };
  const location = useLocation();
  const updatedDatas = location.state?.updatedData;
  const { id } = useParams();

  useEffect(() => {
    setupdatedDatass(updatedDatas);
    fetchData();
    fetchD();
    const roleId = localStorage.getItem("assignId");
    setroleId(roleId);
  }, [updatedDatas]);

  const fetchD = async () => {
    try {
      const response = await axios.get(apiUrl + "/generate_register_no");
      setAddData((prevState) => ({
        ...prevState,
        register_no: response.data.register_no,
      }));
      setgenerateregisterData(response.data.register_no);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [courseData, getCourseData] = useState([]);
  const [courseDatas, getCourseDatas] = useState([]);
  const [coursedata, getCoursedata] = useState([]);
  const [duration, setduration] = useState([]);
  const [fees, setfees] = useState([]);
  const [discount, setdiscount] = useState([]);

  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const [addData, setAddData] = useState({
    admission_date: "",
    qualification: "",
    duractions: "",
    batch_timings: "",
    fees: "",
    discount: "",
    student_type: "",
    payment_type: "",
    father_name: "",
    Source_type: "",
    roll_no: "",
    photo_upload: null,
    id_proof: null,
    leads_id: "",
    date_of_birth: "",
    trainer: "",
    mobile_no: "",
    email: "",
    Enquiry_date: "",
    Prefered_course: "",
    course_id: "",
    register_no: "",
    placement: "",
    current_address: "",
    permanent_address: "",
    student_emi: "",
  });

  // Function to generate roll number with unique pattern
  const generateRollNumber = () => {
    const year = new Date().getFullYear().toString().slice(-2);

    const selectedBranch = branch.find(b => b._id === addData.branch_id);
    const branchPrefix = selectedBranch
      ? selectedBranch.branch_name.substring(0, 3).toUpperCase()
      : "BRN";

    const coursePrefix = updaatedDatass.Prefered_course
      ? updaatedDatass.Prefered_course.substring(0, 3).toUpperCase()
      : "CRS";

    const randomNum = Math.floor(1000 + Math.random() * 9000);

    return `${branchPrefix}-${coursePrefix}-${year}-${randomNum}`;
  };

  // Auto-generate roll number when dependencies change
  useEffect(() => {
    if (addData.branch_id && updaatedDatass.Prefered_course && branch.length > 0) {
      const autoRollNo = generateRollNumber();
      setAddData(prev => ({
        ...prev,
        roll_no: autoRollNo
      }));
    }
  }, [addData.branch_id, updaatedDatass.Prefered_course, branch]);

  const fetchData = async () => {
    try {
      const response = await axios.get(apiUrl + `/leads/${id}`);
      const responsecourse = await axios.get(apiUrl + `/course`);
      const responsecoursees = await axios.get(apiUrl + `/category_list`);
      getCourseDatas(responsecourse.data);
      getCourseData(responsecourse.data);
      getCoursedata(responsecoursees.data);
      const data = responsecourse.data;

      if (responsecourse.status === 200) {
        const filteredCourses = data.filter(
          (course) => course.category_list === updatedDatas.category
        );
        setFilteredData(filteredCourses);
      }

      if (responsecourse.status === 200) {
        const filteredCourses = data.filter(
          (course) => course.course_name === updatedDatas.Prefered_course
        );

        setduration(filteredCourses[0]?.duration);
        setfees(filteredCourses[0]?.fees);
        setdiscount(filteredCourses[0]?.discount);
      }

      if (response && response.data) {
        const data = response.data;
        const filteredData = data.filter((item) => item.status !== "Converted");
        setResponseOldData(filteredData[0]);
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  useEffect(() => {
    fetchDatas();
    fetchDatased();
    filterduration();
  }, [updatedDatas.Prefered_course]);

  useEffect(() => {
    if (responseOldData) {
      const selectedCourse = courseData.find(
        (item) => item.course_id === responseOldData.course_id
      );

      setAddData((prevState) => ({
        ...prevState,
        branch_id: responseOldData.branch_id,
        course_id: responseOldData.course_id,
        student_name: responseOldData.student_name,
        qualification: responseOldData.qualification,
        Source_type: responseOldData.Source_type,
        assign_staff: responseOldData.assign_staff,
        mobile_no: responseOldData.mobile_no,
        email: responseOldData.email,
        Enquiry_date: responseOldData.Enquiry_date,
        Prefered_course: responseOldData.Prefered_course,
        leads_id: responseOldData._id,
        purpose_enquiry: responseOldData.purpose_enquiry,
        fees: selectedCourse ? selectedCourse.fees : "",
        discount: selectedCourse ? selectedCourse.discount : "",
        duractions: selectedCourse ? selectedCourse.duration : "",
      }));
    }
  }, [responseOldData, courseData]);

 const handlesubmit = async (e) => {
  e.preventDefault();

  const formData = new FormData();

  // ✅ Add missing fields
  formData.append("branch_id", addData.branch_id || "");
  formData.append("student_name", addData.student_name || "");

  formData.append("admission_date", addData.admission_date || "");
  formData.append("qualification", addData.qualification || "");
  formData.append("duraction", duration || "");
  formData.append("batch_timings", addData.batch_timings || "");
  formData.append("fees", fees || "");
  formData.append("discount", discount || "");
  formData.append("student_type", addData.purpose_enquiry || "");
  formData.append("payment_type", addData.payment_type || "");
  formData.append("roll_no", addData.roll_no || "");
  formData.append("leads_id", id ? id.toString().trim() : "");
  formData.append("father_name", addData.father_name || "");
  formData.append("date_of_birth", addData.date_of_birth || "");
  formData.append("trainer", addData.trainer || "");
  formData.append("course_id", addData.course_id || "");
  formData.append("register_no", addData.register_no || "");
  formData.append("placement", addData.placement || "");
  formData.append("current_address", addData.current_address || "");
  formData.append("permanent_address", addData.permanent_address || "");
  formData.append("student_emi", addData.student_emi || "");

  // Lead data
  // formData.append("branch_lead", updatedDatas?.branch_id || "");
  formData.append("branch_lead", updatedDatas?.branch_id?._id || updatedDatas?.branch_id || "");
  formData.append("student_name_lead", updatedDatas?.student_name || "");
  formData.append("mobile_no_lead", updatedDatas?.mobile_no || "");
  formData.append("email_lead", updatedDatas?.email || "");
  formData.append("Prefered_course_lead", updaatedDatass?.Prefered_course || "");
  formData.append("category", updaatedDatass?.category || "");
  formData.append("purpose_enquiry_lead", updatedDatas?.purpose_enquiry || "");
  formData.append("Enquiry_date_lead", updatedDatas?.Enquiry_date || "");
  formData.append("Source_type_lead", updatedDatas?.Source_type || "");
  formData.append("contact_type_lead", updatedDatas?.contact_type || "");
  formData.append("assign_staff_lead", updatedDatas?.assign_staff || "");
  formData.append("referal_candidate_name_lead", updatedDatas?.referal_candidate_name || "");
  formData.append("referal_candidate_lead", updatedDatas?.referal_candidate || "");
  formData.append("followups_time_lead", updatedDatas?.followups_time || "");
  formData.append("status_time_lead", updatedDatas?.status_time || "");
  formData.append("followups_status_lead", updatedDatas?.followups_status || "");
  formData.append("followups_notes_lead", updatedDatas?.followups_notes || "");
  formData.append("interest_lead", updatedDatas?.interest || "");

  formData.append("datelist", JSON.stringify(datelist));
  formData.append("emilist", JSON.stringify(emilist));

  if (addData.photo_upload) formData.append("photo_upload", addData.photo_upload);
  if (addData.id_proof) formData.append("id_proof", addData.id_proof);

  const leadsdata = {
    branch_id: addData.branch_id,
    student_name: addData.student_name,
    Source_type: addData.Source_type,
    assign_staff: addData.assign_staff,
    qualification: addData.qualification,
    mobile_no: addData.mobile_no,
    email: addData.email,
    Enquiry_date: addData.Enquiry_date,
    Prefered_course: updaatedDatass.Prefered_course, // ✅ from correct state
    followups_status: "Converted",
  };

  try {
    setLoading(true);

    const response = await axios.post(`${apiUrl}/student`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    if (response.status === 200) {
      const responseleads = await axios.put(
        `${apiUrl}/leads/${addData.leads_id}`,
        leadsdata
      );

      const student_Id = responseleads.data._id;

      const formDataaa = {
        student_Id: student_Id,
        Source_type: "",
        Enquiry_date: "",
        contact_type: updatedDatas?.contact_type || "",
        // assign_staff: updatedDatas?.assign_staff || "",
        assign_staff: updatedDatas?.assign_staff && updatedDatas.assign_staff !== "" 
    ? updatedDatas.assign_staff : null,
        notes: updatedDatas?.followups_notes || "",
        status: updatedDatas?.followups_status || "",
        duration_time: updatedDatas?.duration_time || "",
      };

      await axios.post(apiUrl + "/leadhistroy", formDataaa);

      toast.success("Added successfully!");

      const branch_name = localStorage.getItem("branch_name");
      if (branch_name === "Branches") {
        navigate(`/Duminvoice/${student_Id}`);
      } else {
        navigate("/Studyingstudents");
      }
    }
  } catch (error) {
    // ✅ Log full error to see actual backend message
    console.error("Error:", error.response?.data || error.message);
    toast.error("Failed: " + (error.response?.data?.message || error.message));
  } finally {
    setLoading(false);
  }
};

  const fetchDatas = async () => {
    try {
      const response = await axios.get(apiUrl + "/leads");
      if (response && response.data) {
        const data = response.data;
        setResponseDatas(data);
      } else {
        console.error("No data received from server.");
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [studentId, setSutudentId] = useState([]);
  const [stafftId, setStaffId] = useState([]);
  const [responsesource, setResponsesource] = useState([]);
  const [responsepayment, setResponsepayment] = useState([]);
  const [responsepurpose, setResponsepurpose] = useState([]);

  const fetchDatased = async () => {
    try {
      const response = await axios.get(apiUrl + "/Branch");
      const responsestudent = await axios.get(apiUrl + "/student");
      const responsestaff = await axios.get(apiUrl + "/staff");
      const responsesources = await axios.get(apiUrl + "/source_type");
      const responsepayments = await axios.get(apiUrl + "/paytype");
      const responsepurpose = await axios.get(apiUrl + "/enquiry_purpose");

      setResponsesource(responsesources.data);
      setResponsepurpose(responsepurpose.data);
      setResponsepayment(responsepayments.data);
      setbranch(response.data);
      setSutudentId(responsestudent.data);
      setStaffId(responsestaff.data);
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };

  const [showCallbackDate, setShowCallbackDate] = useState(false);
  const [referaltype, setreferaltype] = useState("");
  const [activeStep, setActiveStep] = useState(0);
  const [datelist, setdatelist] = useState([]);
  const [emilist, setemilist] = useState([]);
  const [showEmiFields, setShowEmiFields] = useState(false);

  const formatDateForInput = (isoDate) => {
    return new Date(isoDate).toISOString().split("T")[0];
  };

  const handleemi_datechange = (e, index) => {
    let date = new Date(e.target.value);
    date.setUTCHours(0, 0, 0, 0);
    const updatedDatelist = [...datelist];
    updatedDatelist[index] = date.toISOString();
    setdatelist(updatedDatelist);
  }

  const handleemi_amountchange = (e, index) => {
    const currentList = typeof emilist === 'string' ? JSON.parse(emilist) : [...emilist];
    const updatedEmilist = [...currentList];
    updatedEmilist[index] = Number(e.target.value);
    setemilist(updatedEmilist);
  }

  const handleEmiGeneration = () => {
    if (addData.student_emi && addData.student_emi > 0) {
      const temp_datelist = generateMonthlyDates(addData.student_emi);
      const monthly_emi = Math.round(fees / addData.student_emi);  // ✓ ROUNDED
      const temp_emilist = [];
      for (let i = 0; i < addData.student_emi; i++) {
        temp_emilist.push(monthly_emi);
      }
      setemilist(temp_emilist);
      setShowEmiFields(true);
    }
  };
  const handleNext = (e) => {
    e.preventDefault();

    if (!validateFields()) {
      return;
    }

    if (activeStep === 1 && addData.payment_type === "emi") {
      if (!addData.student_emi || addData.student_emi === "") {
        alert("Please fill the number of EMI field");
        return;
      }
      if (!showEmiFields) {
        alert("Please click 'Generate EMI Schedule' button");
        return;
      }
    }

    if (activeStep === 1 && addData.payment_type !== "emi") {
      setdatelist([]);
      setemilist([]);
    }

    setActiveStep((prevActiveStep) => prevActiveStep + 1);
  };

  const generateMonthlyDates = (length) => {
    const dates = [];
    let currentDate = new Date();

    for (let i = 0; i < length; i++) {
      let date = new Date(currentDate);
      date.setMonth(date.getMonth() + i);
      date.setUTCHours(0, 0, 0, 0);
      dates.push(date.toISOString());
    }
    setdatelist(dates);
    return dates;
  };

  const handleBack = () => {
    if (activeStep === 1 && addData.payment_type === "emi") {
      setdatelist([]);
      setemilist([]);
      setShowEmiFields(false);
    }
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  const formatDatefitching = (dateString) => {
    if (!dateString) return "";
    return dateString.split("T")[0];
  };

  const [selectedOption, setSelectedOption] = useState("");
  const videoRef = useRef(null);
  const fileInputRef = useRef(null);
  const canvasRef = useRef(null);
  const [image, setImage] = useState(null);
  const [imageFile, setImageFile] = useState(null);
  const [isWebcamActive, setIsWebcamActive] = useState(false);

  const openFileUpload = () => {
    setIsWebcamActive(false);
    setImage(false);
    fileInputRef.current.click();
  };

  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    setAddData({ ...addData, photo_upload: file });
    if (file) {
      const reader = new FileReader();
      reader.onload = () => {
        setImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const startWebcam = async () => {
    setIsWebcamActive(true);
    setImage(false);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (err) {
      console.error("Error accessing webcam: ", err);
    }
  };

  const captureImage = () => {
    setImage(false);

    const video = videoRef.current;
    const canvas = canvasRef.current;
    const context = canvas.getContext("2d");

    if (video && canvas) {
      canvas.width = video.videoWidth;
      canvas.height = video.videoHeight;
      context.drawImage(video, 0, 0, canvas.width, canvas.height);

      const imageUrl = canvas.toDataURL("image/png");
      setImage(imageUrl);

      const byteString = atob(imageUrl.split(",")[1]);
      const mimeString = imageUrl.split(",")[0].split(":")[1].split(";")[0];
      const arrayBuffer = new ArrayBuffer(byteString.length);
      const uintArray = new Uint8Array(arrayBuffer);

      for (let i = 0; i < byteString.length; i++) {
        uintArray[i] = byteString.charCodeAt(i);
      }

      const blob = new Blob([uintArray], { type: mimeString });
      const file = new File([blob], "captured_image.png", {
        type: "image/png",
      });

      setAddData({ ...addData, photo_upload: file });
      stopWebcam();
    }
  };

  const stopWebcam = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
      setIsWebcamActive(false);
    }
  };

  function handleIdProof(e) {
    const file = e.target.files[0];

    if (file) {
      setAddData({ ...addData, id_proof: file });

      const reader = new FileReader();
      reader.onload = () => {
        setImageFile(reader.result);
      };
      reader.readAsDataURL(file);
    }
  }

  const [filteredData, setFilteredData] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");

  const handleCourseFetch = (e) => {
    const selectedCourse = e.target.value;

    setupdatedDatass((prevData) => ({
      ...prevData,
      category: selectedCourse,
    }));
    const filteredCourses = courseDatas.filter(
      (course) => course.category_list === selectedCourse
    );

    setFilteredData(filteredCourses);
  };

  const [filteredDatas, setFilteredDatas] = useState([]);

  const handlecourses = (e) => {
    const selectedCourse = e.target.value;
    setupdatedDatass((prevData) => ({
      ...prevData,
      Prefered_course: selectedCourse,
    }));

    const filteredCourses = courseData.filter(
      (course) => course.course_name === selectedCourse
    );

    setduration(filteredCourses[0]?.duration);
    setfees(filteredCourses[0]?.fees);
    setdiscount(filteredCourses[0]?.discount);
  };

  const [filteredDataduration, setFilteredDataduration] = useState([]);

  const filterduration = (e) => {
    const filteredCourses = courseData.filter(
      (course) => course.course_name === updatedDatas.Prefered_course
    );

    setFilteredDataduration(filteredCourses);
  };

  const changetype = (e) => {
    const selectedtype = e.target.value;
    setAddData((prevData) => ({
      ...prevData,
      purpose_enquiry: selectedtype,
    }));
  };

  const [isCheckBox, setIsCheckBox] = useState(false);

  const handleCheckboxChange = (e) => {
    setIsCheckBox(e.target.checked);
  };

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const validateFields = () => {
    let tempErrors = {};
    let isValid = true;

    if (activeStep === 0) {
      if (!addData.branch_id) {
        tempErrors.branch_id = "Branch is required.";
        isValid = false;
      }
      if (!addData.student_name) {
        tempErrors.student_name = "Student Name is required.";
        isValid = false;
      }
      if (!addData.father_name) {
        tempErrors.father_name = "Father Name is required.";
        isValid = false;
      }
      if (!addData.qualification) {
        tempErrors.qualification = "Qualification is required.";
        isValid = false;
      }
      if (!addData.mobile_no) {
        tempErrors.mobile_no = "Mobile Number is required.";
        isValid = false;
      }
      if (!/^\d{10}$/.test(addData.mobile_no)) {
        tempErrors.mobile_no = "Mobile number must be 10 digits.";
        isValid = false;
      }
      if (!addData.email) {
        tempErrors.email = "Email is required.";
        isValid = false;
      }
      if (
        !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(addData.email)
      ) {
        tempErrors.email = "Please enter a valid email address.";
        isValid = false;
      }
      if (!addData.date_of_birth) {
        tempErrors.date_of_birth = "Date Of Birth is required.";
        isValid = false;
      }
      if (!addData.purpose_enquiry) {
        tempErrors.purpose_enquiry = "Student Type is required.";
        isValid = false;
      }
      if (!addData.photo_upload) {
        tempErrors.photo_upload = "Photo is required.";
        isValid = false;
      }
      if (!addData.id_proof) {
        tempErrors.id_proof = "ID Proof is required.";
        isValid = false;
      }
      setErrors(tempErrors);
      return isValid;
    }

    if (activeStep === 1) {
      if (!addData.permanent_address) {
        tempErrors.permanent_address = "Permanent Address is required.";
        isValid = false;
      }
      if (!addData.current_address) {
        tempErrors.current_address = "Current Address is required.";
        isValid = false;
      }
      if (!addData.roll_no) {
        tempErrors.roll_no = "Roll No is required.";
        isValid = false;
      }
      if (!addData.Prefered_course) {
        tempErrors.Prefered_course = "Course is required.";
        isValid = false;
      }
      if (!addData.Enquiry_date) {
        tempErrors.Enquiry_date = "Enquiry Date is required.";
        isValid = false;
      }
      if (!addData.batch_timings) {
        tempErrors.batch_timings = "Batch Timing is required.";
        isValid = false;
      }
      if (!addData.Source_type) {
        tempErrors.source_type = "Source Type is required.";
        isValid = false;
      }
      if (!addData.admission_date) {
        tempErrors.admission_date = "Admission Date is required.";
        isValid = false;
      }
      if (!addData.trainer) {
        tempErrors.trainer = "Trainer is required.";
        isValid = false;
      }
      if (!addData.payment_type) {
        tempErrors.payment_type = "Payment Type is required.";
        isValid = false;
      }
      if (addData.payment_type === "emi" && !addData.student_emi) {
        tempErrors.student_emi = "Number of EMI is required.";
        isValid = false;
      }
      if (!addData.placement) {
        tempErrors.placement = "Placement selection is required.";
        isValid = false;
      }

      setErrors(tempErrors);
      return isValid;
    }

    setErrors(tempErrors);
    return isValid;
  };

  return (
    <>
      {loading === true ? (
        <div className="loading-overlay">
          <div className="loading-message">
            <img
              className="loadinggif"
              src={require("../../assets/img/output-onlinegiftools.gif")}
            />
          </div>
        </div>
      ) : (
        <div className="d-none"></div>
      )}

      <div
        className="style"
        style={{ marginTop: "-80px", marginBottom: "30px" }}
      >
        <div className="row mb-3">
          <div className="col-lg-11">
            <Link to="/dashboard" className="text-secondary dashBoard_text">
              <b>Dashboard / </b>
            </Link>
            <Link to="#" className="text-secondary dashBoard_text">
              <b>Leads / </b>
            </Link>
            <Link to="/Walkin" className="text-secondary dashBoard_text">
              <b>Walkin / </b>
            </Link>
            <Link to="" className="text-danger dashBoard_text">
              <b>Registration</b>
            </Link>
          </div>
        </div>

        <div className="insermodal">
          <div>
            <h5>Registration</h5>
            <div className="row mt-5 ">
              {/* STEP 1: PERSONAL DETAILS */}
              {activeStep === 0 && (
                <div className="col-lg-12" style={{ marginTop: "-25px" }}>
                  <div className="card  p-4 pb-0">
                    <h4 className="mt-1 mb-3"> Step 1: Personal Details</h4>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="floating-label mt-1">
                            <label className="form-label">
                              <b></b>
                            </label>
                            <select
                              className="form-select"
                              placeholder=""
                              value={addData.branch_id}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  branch_id: e.target.value,
                                })
                              }
                              required
                            >
                              <option value="">Select Branch </option>
                              {branch.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.branch_name}
                                </option>
                              ))}
                            </select>
                            <label
                              className={addData.branch_id ? "filled" : ""}
                            ></label>
                          </div>
                          {errors.branch_id && (
                            <div className="error-text">{errors.branch_id}</div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData.father_name}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  father_name: e.target.value,
                                })
                              }
                            />
                            <label
                              className={addData.father_name ? "filled" : ""}
                            >
                              Father Name
                            </label>
                            {errors.father_name && (
                              <div className="error-text">
                                {errors.father_name}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData.student_name}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  student_name: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={addData.student_name ? "filled" : ""}
                            >
                              Student Name
                            </label>
                          </div>
                          {errors.student_name && (
                            <div className="error-text">
                              {errors.student_name}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData.qualification}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  qualification: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={addData.qualification ? "filled" : ""}
                            >
                              Qualification
                            </label>
                            {errors.qualification && (
                              <div className="error-text">
                                {errors.qualification}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="number"
                              maxLength={10}
                              value={addData.mobile_no}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  mobile_no: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={addData.mobile_no ? "filled" : ""}
                            >
                              Mobile No
                            </label>
                          </div>
                          {errors.mobile_no && (
                            <div className="error-text">
                              {errors.mobile_no}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              value={addData.date_of_birth || ""}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  date_of_birth: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={addData.date_of_birth ? "filled" : ""}
                            >
                              Date of Birth
                            </label>
                            {errors.date_of_birth && (
                              <div className="error-text">
                                {errors.date_of_birth}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="email"
                              value={addData.email}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  email: e.target.value,
                                })
                              }
                              required
                            />
                            <label className={addData.email ? "filled" : ""}>
                              Email
                            </label>
                          </div>
                          {errors.email && (
                            <div className="error-text">{errors.email}</div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-control"
                              value={addData.purpose_enquiry}
                              onChange={changetype}
                              required
                            >
                              <option value="">Select Student Type </option>
                              {responsepurpose.map((item, index) => (
                                <option
                                  key={index}
                                  value={item.enquiry_purpose}
                                >
                                  {item.enquiry_purpose}
                                </option>
                              ))}
                            </select>
                            {errors.purpose_enquiry && (
                              <div className="error-text">{errors.purpose_enquiry}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div>
                            <p>Upload Image</p>
                            <button
                              onClick={openFileUpload}
                              className="btn border btn-secondary mx-2"
                              aria-label="Upload from file"
                            >
                              <i className="fa fa-file mx-2 bg-transparent" />
                              Upload Image
                            </button>
                            <button
                              onClick={startWebcam}
                              className="mx-2 btn border btn-secondary"
                              aria-label="Open webcam"
                            >
                              <i className="fa fa-camera mx-2" />
                              Live Take
                            </button>

                            <input
                              type="file"
                              ref={fileInputRef}
                              onChange={handleFileUpload}
                              accept="image/*"
                              style={{ display: "none" }}
                            />

                            {isWebcamActive && (
                              <div>
                                <video
                                  ref={videoRef}
                                  autoPlay
                                  width="200"
                                  height="200"
                                />
                                <button
                                  className="mx-2 fs-2 bg-transparent border-0"
                                  onClick={(e) => captureImage(e)}
                                  aria-label="Capture image from webcam"
                                >
                                  <i className="fa-solid fa-computer-mouse"></i>
                                </button>
                              </div>
                            )}

                            <canvas
                              ref={canvasRef}
                              style={{ display: "none" }}
                            />

                            {image && (
                              <div>
                                <p></p>
                                <img
                                  src={image}
                                  alt="Uploaded or Captured"
                                  width="200"
                                  height="200"
                                  className="object-fit-cover"
                                />
                              </div>
                            )}
                          </div>
                          {errors.photo_upload && (
                            <div className="error-text">
                              {errors.photo_upload}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="file"
                              onChange={handleIdProof}
                              required
                            />
                            <label className={addData.id_proof ? "filled" : ""}>
                              ID Proof
                            </label>
                            {imageFile && (
                              <div>
                                <p></p>
                                <img
                                  src={imageFile}
                                  alt="Uploaded or Captured"
                                  width="200"
                                  height="200"
                                  className="object-fit-cover"
                                />
                              </div>
                            )}
                            {errors.id_proof && (
                              <div className="error-text">{errors.id_proof}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* STEP 2: ADDRESS DETAILS & EMI - MODIFIED */}
              {activeStep === 1 && (
                <div className="col-lg-12" style={{ marginTop: "-25px" }}>
                  <div className="card p-4 pb-0">
                    <h4 className="mt-1 mb-3"> Step 2: Address Details & EMI</h4>
                    <div className="form-group">
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              value={addData.permanent_address}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  permanent_address: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                addData.permanent_address ? "filled" : ""
                              }
                            >
                              Permanent Address
                            </label>
                            {errors.permanent_address && (
                              <div className="error-text">
                                {errors.permanent_address}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData.roll_no}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  roll_no: e.target.value,
                                })
                              }
                            />
                            <label className={addData.roll_no ? "filled" : ""}>
                              Roll Number
                            </label>
                            {errors.roll_no && (
                              <div className="error-text">{errors.roll_no}</div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              value={addData.current_address}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  current_address: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={
                                addData.current_address ? "filled" : ""
                              }
                            >
                              Current Address
                            </label>
                            {errors.current_address && (
                              <div className="error-text">
                                {errors.current_address}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              disabled
                              placeholder=""
                              value={fees}
                            />
                            <label className={addData.fees ? "filled" : ""}>
                              Fees
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-select"
                              value={updaatedDatass.category || ""}
                              onChange={handleCourseFetch}
                              required
                            >
                              {coursedata.map((item, index) => (
                                <option key={index} value={item.category_name}>
                                  {item.prefix}-{item.category_name}
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              disabled
                              placeholder=""
                              value={discount}
                            />
                            <label className={addData.discount ? "filled" : ""}>
                              Discount
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-select"
                              value={updaatedDatass.Prefered_course}
                              onChange={(e) => handlecourses(e)}
                              required
                            >
                              {filteredData.map((item, index) => (
                                <option key={index} value={item._id}>
                                  {item.course_id}-{item.course_name}
                                </option>
                              ))}
                            </select>
                            <label
                              className={
                                addData.Prefered_course ? "filled" : ""
                              }
                            ></label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              value={
                                addData.Enquiry_date
                                  ? formatDatefitching(addData.Enquiry_date)
                                  : ""
                              }
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  Enquiry_date: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={addData.Enquiry_date ? "filled" : ""}
                            >
                              Enquiry date
                            </label>
                            {errors.Enquiry_date && (
                              <div className="error-text">
                                {errors.Enquiry_date}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              value={duration}
                              className="form-control"
                              disabled
                            ></input>
                            <label className={addData.duration ? "filled" : ""}>
                              Duration
                            </label>
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="date"
                              placeholder=""
                              value={addData.admission_date}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  admission_date: e.target.value,
                                })
                              }
                              required
                            />
                            <label
                              className={addData.admission_date ? "filled" : ""}
                            >
                              Admission Date
                            </label>
                            {errors.admission_date && (
                              <div className="error-text">
                                {errors.admission_date}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <input
                              className="form-control"
                              type="text"
                              placeholder=""
                              value={addData.batch_timings}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  batch_timings: e.target.value,
                                })
                              }
                            />
                            <label
                              className={addData.batch_timings ? "filled" : ""}
                            >
                              Batch Timing
                            </label>
                            {errors.batch_timings && (
                              <div className="error-text">
                                {errors.batch_timings}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <select
                            className="form-select"
                            placeholder=""
                            value={addData.Source_type}
                            onChange={(e) =>
                              setAddData({
                                ...addData,
                                Source_type: e.target.value,
                              })
                            }
                            required
                          >
                            <option value="">Select Source Type </option>
                            {responsesource.map((item, index) => (
                              <option key={index} value={item.source_type}>
                                {item.source_type}
                              </option>
                            ))}
                          </select>
                          {errors.Source_type && (
                            <div className="error-text">
                              {errors.Source_type}
                            </div>
                          )}
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-select"
                              value={addData.payment_type}
                              onChange={(e) => {
                                setAddData({
                                  ...addData,
                                  payment_type: e.target.value,
                                  student_emi: "",
                                });
                                setShowEmiFields(false);
                                setdatelist([]);
                                setemilist([]);
                              }}
                              required
                            >
                              <option value="">Payment Type</option>
                              <option value="Full Payment">Full Payment</option>
                              <option value="emi">EMI</option>
                            </select>
                            {errors.payment_type && (
                              <div className="error-text">
                                {errors.payment_type}
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="col-lg-6">
                          <div className="floating-label">
                            <select
                              className="form-control"
                              value={addData.trainer || ""}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  trainer: e.target.value,
                                })
                              }
                            >
                              <option value="" disabled>
                                Select Trainer
                              </option>
                              {stafftId.map((data, index) => (
                                <option key={index} value={data.name}>
                                  {data.name} - {data.empid}
                                </option>
                              ))}
                            </select>
                            {errors.trainer && (
                              <div className="error-text">{errors.trainer}</div>
                            )}
                          </div>
                        </div>

                        {generateregisterData && (
                          <div className="col-lg-6">
                            <div className="floating-label">
                              <input
                                className="form-control"
                                type="text"
                                placeholder=""
                                disabled
                                value={addData.register_no}
                                onChange={(e) =>
                                  setAddData({
                                    ...addData,
                                    register_no: e.target.value,
                                  })
                                }
                                required
                              />
                              <label
                                className={addData.register_no ? "filled" : ""}
                              >
                                Registration No
                              </label>
                            </div>
                          </div>
                        )}

                        <div className="col-lg-6">
                          <label>Placement</label>
                          <br />
                          <label>
                            <input
                              type="checkbox"
                              name="option"
                              value="Yes"
                              checked={addData.placement === "Yes"}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  placement: e.target.value,
                                })
                              }
                            />
                            &nbsp; Yes &nbsp;
                          </label>
                          <label>
                            <input
                              type="checkbox"
                              name="option"
                              value="No"
                              checked={addData.placement === "No"}
                              onChange={(e) =>
                                setAddData({
                                  ...addData,
                                  placement: e.target.value,
                                })
                              }
                            />
                            &nbsp; No &nbsp;
                          </label>
                          {errors.placement && (
                            <div className="error-text">{errors.placement}</div>
                          )}
                        </div>

                        {/* MODIFIED: EMI fields integrated into Step 2 */}
                        {addData.payment_type === "emi" && (
                          <>
                            <div className="col-lg-6">
                              <div className="floating-label">
                                <input
                                  className="form-control"
                                  type="number"
                                  placeholder=""
                                  value={addData.student_emi}
                                  onChange={(e) =>
                                    setAddData({
                                      ...addData,
                                      student_emi: e.target.value,
                                    })
                                  }
                                />
                                <label
                                  className={addData.student_emi ? "filled" : ""}
                                >
                                  No of EMI
                                </label>
                                {errors.student_emi && (
                                  <div className="error-text">
                                    {errors.student_emi}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="col-lg-6">
                              <button
                                type="button"
                                className="btn btn-primary"
                                onClick={handleEmiGeneration}
                              >
                                Generate EMI Schedule
                              </button>
                            </div>

                            {/* MODIFIED: Show EMI fields in Step 2 itself */}
                            {showEmiFields && datelist.length > 0 && (
                              <>
                                <div className="col-lg-12 mt-3">
                                  <h5 className="text-primary">EMI Schedule</h5>
                                </div>

                                <div className="col-lg-6">
                                  <h6 className="mb-3">EMI Dates</h6>
                                  {datelist.map((date, index) => (
                                    <div className="floating-label mb-2" key={index}>
                                      <input
                                        className="form-control"
                                        type="date"
                                        value={formatDateForInput(date)}
                                        onChange={(e) => handleemi_datechange(e, index)}
                                      />
                                      <label className="filled">
                                        EMI Date {index + 1}
                                      </label>
                                    </div>
                                  ))}
                                </div>

                                <div className="col-lg-6">
                                  <h6 className="mb-3">EMI Amounts</h6>
                                  {emilist.map((emi, index) => (
                                    <div className="floating-label mb-2" key={index}>
                                      <input
                                        className="form-control"
                                        type="number"
                                        value={emi}
                                        onChange={(e) => handleemi_amountchange(e, index)}
                                      />
                                      <label className="filled">
                                        EMI Amount {index + 1}
                                      </label>
                                    </div>
                                  ))}
                                </div>
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {/* STEP 3: CONFIRMATION - MODIFIED TO SINGLE PAGE */}
              {activeStep === 2 && (
                <div className="col-lg-12" style={{ marginTop: "-40px" }}>
                  <div className="card p-2">
                    {/* <h4 className="mt-1 mb-3 text-center">Registration Confirmation</h4> */}

                    <div className="row">
                      {/* Left Column - Profile Card */}
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card">
                          <div className="card-body">
                            <div className="mb-3">
                              <img
                                src={image}
                                alt="Student"
                                className="img-fluid rounded"
                                style={{ maxHeight: "150px", objectFit: "cover", width: "100%" }}
                              />
                            </div>
                            <div>
                              <h5 className="mb-2">{addData.student_name || ""}</h5>
                              <p className="mb-1"><i className="fa fa-phone"></i> {addData.mobile_no || ""}</p>
                              <p className="mb-1"><i className="fa fa-id-card"></i> {addData.register_no || ""}</p>
                              <p className="mb-0"><i className="fa fa-book"></i> {addData.Prefered_course || ""}</p>
                            </div>
                          </div>
                        </div>

                        {/* EMI Schedule Card */}
                        {addData.payment_type === "emi" && datelist.length > 0 && (
                          <div className="card mt-3">
                            <div className="card-header bg-primary text-white">
                              <strong>EMI Schedule</strong>
                            </div>
                            <div className="card-body p-2" style={{ maxHeight: "300px", overflowY: "auto" }}>
                              <div className="table-responsive">
                                <table className="table table-sm">
                                  <thead>
                                    <tr>
                                      <th>Date</th>
                                      <th>Amount</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {datelist.map((date, index) => (
                                      <tr key={index}>
                                        <td>{formatDateForInput(date)}</td>
                                        <td>₹{emilist[index]}</td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>

                      {/* Middle Column - Personal Details */}
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card">
                          <div className="card-header bg-info text-white">
                            <strong>Personal Details</strong>
                          </div>
                          <div className="card-body p-2" style={{ fontSize: "14px" }}>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Branch:</strong></div>
                              <div className="col-6">
                                {branch.find(item => item._id === addData.branch_id)?.branch_name}
                              </div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Roll No:</strong></div>
                              <div className="col-6">{addData.roll_no}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Father Name:</strong></div>
                              <div className="col-6">{addData.father_name}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Qualification:</strong></div>
                              <div className="col-6">{addData.qualification}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>DOB:</strong></div>
                              <div className="col-6">{addData.date_of_birth}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Email:</strong></div>
                              <div className="col-6" style={{ fontSize: "12px" }}>{addData.email}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Current Address:</strong></div>
                              <div className="col-6">{addData.current_address}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Permanent Address:</strong></div>
                              <div className="col-6">{addData.permanent_address}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Student Type:</strong></div>
                              <div className="col-6">{addData.purpose_enquiry}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Source:</strong></div>
                              <div className="col-6">{addData.Source_type}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Batch Timing:</strong></div>
                              <div className="col-6">{addData.batch_timings}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Placement:</strong></div>
                              <div className="col-6">{addData.placement}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Trainer:</strong></div>
                              <div className="col-6">{addData.trainer}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Admission Date:</strong></div>
                              <div className="col-6">{addData.admission_date}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Enquiry Date:</strong></div>
                              <div className="col-6">{addData.Enquiry_date}</div>
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Right Column - ID Proof & Fee Details */}
                      <div className="col-lg-4 col-md-12 mb-3">
                        <div className="card mb-3">
                          <div className="card-header bg-warning text-dark">
                            <strong>ID Proof</strong>
                          </div>
                          <div className="card-body p-2 text-center">
                            <img
                              src={imageFile}
                              alt="ID Proof"
                              className="img-fluid"
                              style={{ maxHeight: "200px", objectFit: "contain" }}
                            />
                          </div>
                        </div>

                        <div className="card">
                          <div className="card-header bg-success text-white">
                            <strong>Fee Details</strong>
                          </div>
                          <div className="card-body p-2">
                            <div className="row mb-2">
                              <div className="col-6"><strong>Fees:</strong></div>
                              <div className="col-6">₹{fees}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Discount:</strong></div>
                              <div className="col-6">₹{discount || 0}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Payment Type:</strong></div>
                              <div className="col-6">{addData.payment_type}</div>
                            </div>
                            <div className="row mb-2">
                              <div className="col-6"><strong>Course Duration:</strong></div>
                              <div className="col-6">{duration}</div>
                            </div>
                          </div>
                        </div>

                        <div className="card mt-3">
                          <div className="card-body">
                            <div className="form-check mb-3">
                              <input
                                type="checkbox"
                                className="form-check-input"
                                id="agree"
                                checked={isCheckBox}
                                onChange={handleCheckboxChange}
                              />
                              <label className="form-check-label" htmlFor="agree">
                                I Agree to all conditions
                              </label>
                            </div>

                            <div className="gap-2 d-flex justify-content-between">
                              <button
                                className="btn btn-secondary"
                                onClick={handlecancel}
                              >
                                Cancel
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={handleBack}
                              >
                                Back
                              </button>
                              <button
                                className="btn btn-success"
                                onClick={handlesubmit}
                                disabled={!isCheckBox}
                              >
                                Submit
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Navigation Buttons */}
        {activeStep !== steps.length - 1 && (
          <div style={{ marginTop: "20px" }}>
            {activeStep === 0 ? (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "gray",
                  marginRight: "10px",
                  color: "white",
                }}
                onClick={() => navigate("/Walkin")}
              >
                Back
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{
                  backgroundColor: "gray",
                  marginRight: "10px",
                  color: "white",
                }}
                onClick={handleBack}
              >
                Back
              </Button>
            )}

            <Button variant="contained" color="primary" onClick={handleNext}>
              Next
            </Button>
          </div>
        )}
      </div>
    </>
  );
}

export default Registration;
